module.exports = __webpack_public_path__ + "img/14.f73396dd.png";